import {z} from 'zod'

import {KpiNumberVariantEnum} from '@sdox/api'

export type KpiFormSchema = z.infer<typeof kpiFormSchema>

export const kpiFormSchema = z.union([
  z.object({
    title: z.string().min(1),
    value: z.coerce.number().safe(),
    prefix: z.string().nullish(),
    suffix: z.string().min(1),
    subtitle: z.string().nullish(),
    variant: z.nativeEnum(KpiNumberVariantEnum).or(z.literal('none')),
  }),
  z.object({
    title: z.string().min(1),
    value: z.string().min(1),
    prefix: z.string().nullish(),
    suffix: z.string().min(1),
    subtitle: z.string().nullish(),
    variant: z.undefined(),
  }),
])
